
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Portfolio from "./components/Portfolio";
import Education from "./components/Education";
import SkillNote from "./components/SkillNote";
import Experience from "./components/Experience";
import Brands from "./components/Brands";
// ...existing code...
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Features />
      <Portfolio />
      <Education />
      <SkillNote />
      <Experience />
      <Brands />
      <Footer />
    </div>
  );
}

export default App;
